import type { QuoteTag, OptionsDocument } from 'paintscout'

export function getQuoteTags(args: { options: OptionsDocument; deleted?: boolean }): QuoteTag[] {
  const { options, deleted = false } = args
  const { quoteTags } = options.options

  if (!quoteTags) {
    return []
  }

  return quoteTags.order
    .map((orderItem) => {
      const item = quoteTags.values[orderItem]
      if (!item) {
        return null
      }
      if (item.deleted && !deleted) {
        return null
      }
      return {
        name: orderItem,
        label: item.label,
        color: item.color
      }
    })
    .filter((item) => item)
}
